import { GlobalValueResult } from "../types/simulation-view-table.model";

export const calculateGlobalValues = (
  rows: any[],
  pa1Key: string,
  pa2Key?: string,
  defaultPA1Value: any = 1,
  defaultPA2Value: any = ''
): GlobalValueResult => {
  const extractValues = (rows: any[], key: string): any[] => {
    const values: any[] = [];
    rows.forEach((row) => {
      if (row.parent?.data?.[key] !== undefined) {
        values.push(row.parent.data[key]);
      }
      if (row.children && row.children.length > 0) {
        row.children.forEach((child: any) => {
          if (child.parent?.data?.[key] !== undefined) {
            values.push(child.parent.data[key]);
          }
        });
      }
    });
    return values;
  };

  const getGlobalValue = (values: any[], defaultValue: string): string => {
    const uniqueValues = [...new Set(values.filter((v) => v !== null && v !== undefined))];
    if (uniqueValues.length === 0) {
      return defaultValue; // All rows are empty
    } else if (uniqueValues.length === 1) {
      return uniqueValues[0]; // All rows have the same value
    } else {
      return ''; // Rows have different values
    }
  };

  // Extract values for PA1 and PA2
  const pa1Values = extractValues(rows, pa1Key);
  const globalPA1Value = getGlobalValue(pa1Values, defaultPA1Value);

  // Extract values for PA2 (if the key is provided)
  let globalPA2Value: string | undefined = undefined;
  if (pa2Key) {
    const pa2Values = extractValues(rows, pa2Key);
    globalPA2Value = getGlobalValue(pa2Values, defaultPA2Value);
  }

  return { globalPA1Value, globalPA2Value };

};